import { httpClient } from "./httpClient";

const base = "/api/contratos/inscripcion";

const getAuthHeader = () => {
  const token = typeof localStorage !== "undefined" ? localStorage.getItem("token") : null;
  return token ? { Authorization: `Bearer ${token}` } : {};
};

const getDownloadFilename = (res, matriculaId) => {
  const disposition = res.headers.get("content-disposition") || "";
  const match = disposition.match(/filename="?([^"]+)"?/i);
  if (match && match[1]) return match[1];
  return `contrato-matricula-${matriculaId}.pdf`;
};

export const generarContratoInscripcion = (matriculaId) =>
  httpClient.post(`${base}/generar-con-ficha`, { matricula_id: matriculaId });

export const descargarContratoInscripcion = async (matriculaId) => {
  const url = `${httpClient.baseUrl}${base}/${matriculaId}`;
  const res = await fetch(url, {
    method: "GET",
    headers: {
      ...getAuthHeader(),
      Accept: "application/pdf",
    },
  });

  if (!res.ok) {
    let message = res.statusText || "No se pudo descargar el contrato.";
    const ct = res.headers.get("content-type") || "";
    try {
      if (ct.includes("application/json")) {
        const data = await res.json();
        if (data?.message) message = data.message;
      } else {
        const text = await res.text();
        if (text) message = text;
      }
    } catch {
      // ignore parse errors
    }
    const err = new Error(message);
    err.status = res.status;
    throw err;
  }

  const blob = await res.blob();
  const filename = getDownloadFilename(res, matriculaId);
  const downloadUrl = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = downloadUrl;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  setTimeout(() => window.URL.revokeObjectURL(downloadUrl), 750);

  return true;
};

const contratosInscripcionService = {
  generar: generarContratoInscripcion,
  descargar: descargarContratoInscripcion,
};

export default contratosInscripcionService;
